<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.products') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.typeRadios"
                    color="#A3CA76"
                    vsValue="product"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.product') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.selecttype_detail1') }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.typeRadios"
                    color="#A3CA76"
                    vsValue="service"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.service') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.selecttype_detail2') }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          v-if="form.chooseType == 'product'"
          class="section-product">
          <section class="mb-1">
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.general')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label>{{ $t('message.productimage') }}</label>
                      <!-- <img src="./../../../../assets/images/items/1.jpg"> -->
                      <!-- <img src="https://s3-ap-southeast-1.amazonaws.com/treesoft-test-2/subfolder/item-1.jpg"> -->
                      <!-- v-bind:files="['http://localhost:8080/static/img/1.9cafa82.jpg']" -->
                      <!-- v-bind:files="['https://treesoft-test-2.s3.amazonaws.com/subfolder/item-1.jpg']" -->
                      <file-pond
                        ref="pond"
                        :server="{process, revert, restore, load, fetch}"
                        name="file"
                        className="my-pond"
                        acceptedFileTypes="image/jpeg, image/png"
                        imagePreviewHeight="240"
                        imageCropAspectRatio="1:1"
                        labelIdle="อัพโหลดรูปภาพ"
                        labelTapToUndo=""
                        labelTapToCancel="คลิกเพื่อยกเลิก"
                        labelFileProcessing="กำลังอัปโหลด"
                        labelFileLoading="กำลังโหลด"
                        labelFileProcessingComplete=""
                        labelButtonRemoveItem="นำออก"
                        labelFileProcessingError="เกิดข้อผิดพลาด"
                        labelButtonAbortItemProcessing="ยกเลิก"
                        @init="handleFilePondInit"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.productname') }} *</label>
                      <input
                        :class="[{'is-invalid': bindClass.product_name}]"
                        v-model="form.productName"
                        type="text"
                        class="form-control">
                      <div
                        v-if="this.getNames.includes(form.productName)"
                        class="invalid-feedback">
                        {{ $t('message.namecannotbeduplicated') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.category') }}</label>
                      <selectize
                        :options="form.optionsCat"
                        v-model="form.catName"
                        :multiple="false"
                        :create="true"
                        :placeholder="$t('placeholder.selectorcreate')"
                        default=""
                        @change="onChangedCat()"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.unit') }}</label>
                      <selectize
                        :options="form.optionsUnit"
                        v-model="form.unit"
                        :multiple="false"
                        :create="true"
                        :placeholder="$t('placeholder.selectorcreate')"
                        default=""
                        @change="onChangedUnit()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.pricing')"/>
              <div class="form-row">

                <template v-if="form.tempPrices.length == 0">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.price') }}</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button
                              class="btn dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              style="border: 1px solid #ced4da;">
                              <template v-if="form.isFixedPrice">
                                {{ $t('message.fixedprice') }}
                              </template>
                              <template v-if="!form.isFixedPrice">
                                {{ $t('message.variableprice') }}
                              </template>
                            </button>
                            <div class="dropdown-menu">
                              <a
                                class="dropdown-item"
                                @click="form.isFixedPrice = true;form.textField_ProductPrice = 0">{{ $t('message.fixedprice') }}</a>
                              <a
                                class="dropdown-item"
                                @click="form.isFixedPrice = false;form.textField_ProductPrice = null">{{ $t('message.variableprice') }}</a>
                            </div>
                          </div>
                          <input
                            :disabled="!form.isFixedPrice"
                            v-model="form.textField_ProductPrice"
                            type="text"
                            class="form-control text-right text-select-all"
                            @keypress="numberOnly"
                            @keyup="form.textField_ProductPrice = setToValidNumber(form.textField_ProductPrice)"
                            @blur="form.textField_ProductPrice = setToCustomDigitsNumber(form.textField_ProductPrice)">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.cost') }}</label>
                        <input
                          v-model="form.textField_ProductCost"
                          type="text"
                          class="form-control text-right text-select-all"
                          @keypress="numberOnly"
                          @keyup="form.textField_ProductCost = setToValidNumber(form.textField_ProductCost)"
                          @blur="form.textField_ProductCost = setToCustomDigitsNumber(form.textField_ProductCost)">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.barcode') }}</label>
                        <input
                          v-model="form.barcode"
                          type="text"
                          class="form-control text-select-all">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group form-row">
                      <div class="col-md-6">
                        <div class="form-group row">
                          <div class="col-md-12">
                            <label>{{ $t('message.sku') }}</label>
                            <input
                              v-model="form.stock.sku"
                              type="text"
                              class="form-control">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row">
                          <div class="col-md-12">
                            <label>{{ $t('message.stockcount') }}</label>
                            <input
                              v-model="form.stock.count"
                              type="text"
                              class="form-control text-right text-select-all"
                              @keypress="numberOnly"
                              @keyup="form.stock.count = setToValidNumber(form.stock.count)"
                              @blur="form.stock.count = form.stock.count > 0 ? setToCustomDigitsNumber(form.stock.count) : null">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="col-md-12 mt-1">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <template>
                        <button
                          v-if="form.prices.length > 0"
                          class="btn btn-light"
                          @click="openModalPrices()">
                          {{ $t('message.addprices', {number: form.prices.length}) }}
                        </button>
                        <button
                          v-else
                          class="btn btn-light"
                          @click="openModalPrices()">
                          {{ $t('message.addmoreprices') }}
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="mb-3">
            <div class="col-md-12 no-padding">
              <section-header :title="$t('app.inventory.title')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <vs-switch
                    v-model="form.assign_inventory"
                    style="float: left;margin-right: 10px;"
                    color="#A3CA76"/>
                  {{ $t('message.assignitemto', {string: $t('app.inventory.title')}) }}
                  <a
                    href="https://www.treesoft.io/th/manual/product#item"
                    target="_blank">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
                </div>
              </div>
            </div>
          </section>
          <section class="mb-3">
            <div class="col-md-12 no-padding">
              <section-header :title="$t('app.pos.title')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <vs-switch
                    v-model="form.assign_pos"
                    style="float: left;margin-right: 10px;"
                    color="#A3CA76"/>
                  {{ $t('message.assignitemto', {string: $t('app.pos.title')}) }}
                  <a
                    href="https://www.treesoft.io/th/manual/product#item"
                    target="_blank">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          v-if="form.chooseType == 'service'"
          class="section-service">
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.service')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label>{{ $t('message.productimage') }}</label>
                      <file-pond
                        ref="pond"
                        :server="{process, revert, restore, load, fetch}"
                        name="file"
                        className="my-pond"
                        acceptedFileTypes="image/jpeg, image/png"
                        imagePreviewHeight="240"
                        imageCropAspectRatio="1:1"
                        labelIdle="อัพโหลดรูปภาพ"
                        labelTapToUndo=""
                        labelTapToCancel="คลิกเพื่อยกเลิก"
                        labelFileProcessing="กำลังอัปโหลด"
                        labelFileLoading="กำลังโหลด"
                        labelFileProcessingComplete=""
                        labelButtonRemoveItem="นำออก"
                        labelFileProcessingError="เกิดข้อผิดพลาด"
                        labelButtonAbortItemProcessing="ยกเลิก"
                        @init="handleFilePondInit"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.servicename') }} *</label>
                      <input
                        :class="[{'is-invalid': bindClass.product_name}]"
                        v-model="form.productName"
                        type="text"
                        class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.pricing')"/>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.price') }}</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <button
                            class="btn dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            style="border: 1px solid #ced4da;">
                            <template v-if="form.isFixedPrice">
                              {{ $t('message.fixedprice') }}
                            </template>
                            <template v-if="!form.isFixedPrice">
                              {{ $t('message.variableprice') }}
                            </template>
                          </button>
                          <div class="dropdown-menu">
                            <a
                              class="dropdown-item"
                              @click="form.isFixedPrice = true;form.textField_ServicePrice = 0">{{ $t('message.fixedprice') }}</a>
                            <a
                              class="dropdown-item"
                              @click="form.isFixedPrice = false;form.textField_ServicePrice = null">{{ $t('message.variableprice') }}</a>
                          </div>
                        </div>
                        <input
                          :disabled="!form.isFixedPrice"
                          v-model="form.textField_ServicePrice"
                          type="text"
                          class="form-control text-right text-select-all"
                          @keypress="numberOnly"
                          @keyup="form.textField_ServicePrice = setToValidNumber(form.textField_ServicePrice)"
                          @blur="form.textField_ServicePrice = setToCustomDigitsNumber(form.textField_ServicePrice)">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.cost') }}</label>
                      <input
                        v-model="form.textField_ServiceCost"
                        type="text"
                        class="form-control text-right text-select-all"
                        @keypress="numberOnly"
                        @keyup="form.textField_ServiceCost = setToValidNumber(form.textField_ServiceCost)"
                        @blur="form.textField_ServiceCost = setToCustomDigitsNumber(form.textField_ServiceCost)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="mb-3">
            <div class="col-md-12 no-padding">
              <section-header :title="$t('app.pos.title')"/>
              <div class="form-row">
                <div class="col-md-12">
                  <vs-switch
                    v-model="form.assign_pos"
                    style="float: left;margin-right: 10px;"
                    color="#A3CA76"/>
                  {{ $t('message.assignitemto', {string: $t('app.pos.title')}) }}
                  <a
                    href="https://www.treesoft.io/th/manual/product#item"
                    target="_blank">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section
          v-if="form.chooseType !== null"
          class="action-bar">
          <template>
            <div
              v-if="!$store.state.app.loading"
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only"
                      @click="clearForm()">{{ $t('button.cancel') }}</button> -->
              <button
                type="button"
                class="btn btn-web"
                @click="save({isCreateAnother: false})">{{ $t('button.save') }}</button>
            </div>
            <div
              v-else
              class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-web"
                disabled><i class="fas fa-spinner spin"/></button>
            </div>
          </template>
        </section>
      </template>

    </div>

    <div
      id="pricesModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="pricesModalTitle"
              class="modal-title">{{ $t('message.addmoreprices') }}</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="cancelPrices()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <attribute
              v-if="form.isShowModalPrices"
              :trickReset="form.trickResetAttribute"
              :validation="form.trickValidationAttribute"
              :data="form.attributes"
              :defaultPrices="form.defaultPrices"
              page="new"
              @data="submitForm"
            />
          </div>
          <div class="modal-footer">
            <a
              href="https://www.treesoft.io/th/manual/product#item"
              target="_blank"
              style="margin-right: 5px;">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
            <button
              type="button"
              class="btn btn-light"
              @click="cancelPrices()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="resetPrices()">{{ $t('button.reset') }}</button>
            <button
              type="button"
              class="btn btn-web"
              @click="applyPrices()">{{ $t('button.apply') }}</button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform)

export default {
  name: 'ProductNew',
  components: {
    FilePond,
  },
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      form: {
        typeRadios: 'product',
        chooseType: 'product', // default
        formEdited: false,
        productName: null,

        textField_ProductPrice: 0,
        textField_ProductCost: null,
        isFixedPrice: true,

        textField_ServicePrice: 0,
        textField_ServiceCost: null,

        barcode: null,

        stock: {
          sku: '',
          count: null,
        },

        brandName: null,
        catName: null,
        unit: null,

        tempPrices: [],
        tempAttrs: [],

        optionsBrand: [{
          value: 'opt1',
          text: 'opt1',
        }, {
          value: 'opt2',
          text: 'opt2',
        }],
        optionsCat: [],
        optionsUnit: [],

        trickResetAttribute: 0,
        trickValidationAttribute: 0,
        attributes: [],
        prices: [],
        defaultPrices: null,
        images: [{
          type: 'original',
          location: null,
        }, {
          type: 'thumbnail',
          location: null,
        }],

        assign_inventory: false,
        assign_pos: false,

        isShowModalPrices: false,
      },

      originalForm: null,

      disabled: {
        btn_save: false,
      },

      bindClass: {
        product_name: null,
      },
    }
  },
  computed: mapGetters({
    categories: 'getCategories',
    units: 'getUnits',
    nextSkucode: 'getNextSkuCode',
    allSkuCode: 'getAllSkuCode',
    getNames: 'getNames',
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    'form.productName': {
      handler: function (after) {
        let val = after == null ? '' : after

        this.form.formEdited = true

        if (val.trim().length == 0 || this.getNames.includes(val)) {
          this.bindClass.product_name = 'is-invalid'
        } else {
          this.bindClass.product_name = null
        }
      },
      deep: true,
    },
    'form.typeRadios': {
      handler: function (newVal) {
        if (this.form.formEdited) {
          // alert are you sure to close this tab
        }
        // chanage chooseType
        this.form.chooseType = newVal

        // clear form
        this.form.productName = null
        this.form.prices = []
        this.form.tempPrices = []
        this.form.tempAttrs = []
        this.form.textField_ProductPrice = this.setToCustomDigitsNumber(0)
        this.form.textField_ProductCost = null
        this.form.textField_ServicePrice = this.setToCustomDigitsNumber(0)
        this.form.textField_ServiceCost = null
        this.form.isFixedPrice = true

        // clear selectize
        this.form.brandName = null
        this.form.catName = null
        this.form.unit = null

        // clear bindClass
        this.bindClass.product_name = null
      },
      deep: true,
    },
    'categories': {
      handler: function (newVal) {
        this.form.optionsCat = []
        let items = newVal
        for (let i in items) {
          this.form.optionsCat.push({
            text: items[i].category_name,
            value: items[i].category_name,
          })
        }
      },
      deep: true,
    },
    'units': {
      handler: function (newVal) {
        this.form.optionsUnit = []
        let items = newVal
        for (let i in items) {
          this.form.optionsUnit.push({
            text: items[i].name,
            value: items[i].name,
          })
        }
      },
      deep: true,
    },
    'form.stock': {
      handler () {
        if (this.form.assign_inventory) return

        const { count } = this.form.stock
        if (count === null) {
          this.form.assign_inventory = false
        } else {
          if (count >= 0) {
            this.form.assign_inventory = true
          }
        }
      },
      deep: true,
    },
    'form.assign_inventory': {
      handler () {
        if (!this.form.assign_inventory) {
          this.form.stock.count = null
          this.form.prices.map((price) => {
            price.stock_count = null
          })
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    await Promise.all([
      this.$store.dispatch('getCategories'),
      this.$store.dispatch('getUnits'),
      this.$store.dispatch('getNextSkuCode'),
      this.$store.dispatch('getAllSkuCode'),
      this.$store.dispatch('getAllSkuAttributes'),
      this.$store.dispatch('getNames'),
    ])

    // set data
    this.form.textField_ProductPrice = this.setToCustomDigitsNumber(this.form.textField_ProductPrice)
    this.form.textField_ServicePrice = this.setToCustomDigitsNumber(this.form.textField_ServicePrice)
    // set originalForm
    this.originalForm = _.cloneDeep(this.form)
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 1,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#pricesModal')
  },
  updated: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearProducts'])
    this.leavePage(this.$Progress, ['clearCategories'])
  },
  methods: {
    isValid () {
      var isValid = true

      let productName = this.form.productName == null ? '' : this.form.productName

      if (typeof productName === 'string') {
        if (productName.trim().length == 0 || this.getNames.includes(productName)) {
          this.bindClass.product_name = 'is-invalid'
          isValid = false
        }
      }

      return isValid
    },
    cancelPrices () {
      let that = this

      if (this.form.prices.length > 0) {
        var temp = JSON.stringify(this.form.tempPrices)
        this.form.prices = JSON.parse(temp)
        var temp2 = JSON.stringify(this.form.tempAttrs)
        this.form.attributes = []
        setTimeout(() => {
          that.form.attributes = JSON.parse(temp2)
        }, 1)
      }

      this.closeModalPrices()
    },
    resetPrices () {
      this.form.trickResetAttribute++
    },
    applyPrices () {
      this.form.trickValidationAttribute++
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    /*
     *  this function response when trickValidationAttribute is chanaged, <attribute></attribute> component
     */
    submitForm (isValid, data) {
      if (!isValid) {
        return false
      }

      this.form.prices = data

      if (this.form.prices.length > 0) {
        this.form.tempPrices = _.cloneDeep(this.form.prices)
        this.form.defaultPrices = _.cloneDeep(this.form.prices)
        this.form.tempAttrs = _.cloneDeep(this.form.attributes)
      } else {
        this.form.tempPrices = []
        this.form.defaultPrices = []
        this.form.tempAttrs = []
      }

      const isSetStockCount = !this.form.prices.map(({ stock_count }) => stock_count).every((value) => value === null)

      if (isSetStockCount) {
        this.form.assign_inventory = true
      }

      this.closeModalPrices()
    },
    async save ({ isCreateAnother }) {
      if (!this.isValid()) {
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
      }

      let dataSet = {}

      if (this.form.productName) dataSet['product_name'] = this.form.productName
      if (this.form.typeRadios) dataSet['type'] = this.form.typeRadios
      if (this.form.typeRadios == 'service') {
        dataSet['assign_pos'] = this.form.assign_pos
        dataSet['prices'] = [{
          price: this.form.textField_ServicePrice,
          cost: this.form.textField_ServiceCost,
        }]
      } else if (this.form.typeRadios == 'product') {
        dataSet['assign_inventory'] = this.form.assign_inventory
        dataSet['assign_pos'] = this.form.assign_pos
        if (this.form.tempPrices.length == 0) {
          dataSet['prices'] = [{
            price: this.form.textField_ProductPrice,
            cost: this.form.textField_ProductCost,
            barcode: this.form.barcode,
            sku: this.form.stock.sku,
            stock_count: this.form.stock.count,
          }]
        } else {
          dataSet['prices'] = this.form.prices
        }
      }
      if (this.form.brandName) dataSet['brand_name'] = this.form.brandName
      if (this.form.catName) dataSet['category_name'] = this.form.catName
      if (this.form.unit) dataSet['unit'] = this.form.unit

      if (this.form.images[0].location && this.form.images[1].location) {
        var images = {}
        this.form.images.map(img => {
          images[img.type] = img.location
        })
        dataSet['images'] = images
      }

      // parseFloat && delete key we don't need
      this.clean_dataSet(dataSet)

      // call api
      let res = await this.$store.dispatch('insertProduct', dataSet)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: dataSet.product_name }),
          color: 'success',
          icon: 'cloud',
        })

        if (!isCreateAnother) {
          // go to GoodsIssueAll page
          return this.$router.push({
            name: 'ProductAll',
            query: {
              ignoreDiscardAlert: true,
            },
          })
        } else {
          // clear form
          this.clearForm()
          // scroll to top
          $('html, body').animate({ scrollTop: 0 }, 'slow')
        }
      }
    },
    clean_dataSet (dataSet) {
      dataSet.prices.map(p => {
        if (typeof p.price === 'string') {
          if (p.price.trim() == '') {
            p.price = 0
          } else {
            p.price = parseFloat(p.price)
          }
        }
        if (typeof p.cost === 'string') {
          if (p.cost.trim() == '') {
            p.cost = null
          } else {
            p.cost = parseFloat(p.cost)
          }
        }
        if (typeof p.barcode === 'string') {
          if (p.barcode.trim() == '') {
            p.barcode = null
          }
        }
        if (typeof p.sku === 'string') {
          if (p.sku.trim() == '') {
            p.sku = null
          }
        }
        if (typeof p.stock_count === 'string') {
          if (p.stock_count.trim() == '') {
            p.stock_count = null
          } else {
            p.stock_count = parseInt(p.stock_count)
          }
        }
        if (p.is_fixedprice !== undefined) {
          delete p.is_fixedprice
        }
        if (p.is_custom_sku !== undefined) {
          delete p.is_custom_sku
        }
      })
    },
    openModalPrices () {
      var that = this
      // set to default
      if (this.form.prices.length == 0) {
        this.autoGenSku = false
        this.replacePrice = false
        this.replaceCost = false
      }
      this.form.isShowModalPrices = true
      $('#pricesModal').modal('show')
    },
    closeModalPrices () {
      this.form.isShowModalPrices = false
      $('#pricesModal').modal('hide')
    },
    onChangedBrand () {

    },
    onChangedCat () {

    },
    onChangedUnit () {

    },
    handleFilePondInit: function () {

    },
    async process  (fieldName, file, metadata, load, error, progress, abort) {
      var that = this

      this.disabled.btn_save = true

      try {
        progress(true, 0, 1024)

        var formData = new FormData()
        formData.append(fieldName, file, file.name)
        formData.append('app_id', 2)
        formData.append('module_id', 1)

        let res = await that.$store.dispatch('uploadImage', formData)

        if (!res.success) {
          error(res.error)
        }

        res.data.map(img => {
          if (img.type == 'original') {
            that.form.images[0].location = img.location
          }
          if (img.type == 'thumbnail') {
            that.form.images[1].location = img.location
          }
        })

        load('success')

        this.disabled.btn_save = false

        return { abort: () => { abort() } }
      } catch (e) {
        return { abort: () => { abort() } }
      }
    },
    async revert (uniqueFileId, load, error) {
      this.checkToDeleteS3Images()

      this.disabled.btn_save = false
    },
    load (uniqueFileId, load, error) {
      error()
    },
    fetch (url, load, error, progress, abort, headers) {
      error('Solo archivos locales')
    },
    restore (uniqueFileId, load, error, progress, abort, headers) {
      error()
    },
    handleError (error, e) {

    },
    async checkToDeleteS3Images () {
      if (!this.form.images[0].location && !this.form.images[1].location) {
        return false
      }

      var dataSet = {
        'bucket': null,
        'objects': [],
        'app_id': 2,
        'module_id': 1,
      }

      this.form.images.map((img, idx) => {
        let bucket = this.getS3Bucket(img.location)
        let key = this.getS3Key(img.location)

        if (!dataSet.bucket) {
          dataSet.bucket = bucket
        }

        dataSet.objects.push({
          'key': key,
        })
      })

      let res = await this.$store.dispatch('deleteImage', dataSet)

      // set images location to null
      this.form.images[0].location = null
      this.form.images[1].location = null
    },
  },
}
</script>

<style scoped>
  section.choose-type .form-check input, section.choose-type .form-check label {
    cursor: pointer;
  }
  section .form-check p {
    margin: 0;
  }
  .wrap-attributes-input .form-group {
    margin-bottom: 4px;
  }
  .wrap-attributes-input .form-group:last-of-type {
    margin-bottom: 0;
  }
  .wrap-attributes-input .inner-attribute-name {
    padding-right: 2px;
    z-index: 2;
  }
  @media (max-width: 575.98px) {
    .choose-type .wrapper > div {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/items/product/New.vue